
export default function cheackdate(data) {
    var date = data.split("/")
    console.log(date[0], date[1], date[2]);
    var year = date[2] -543
    var month = Number(date[1]-1) 
    var ddd = new Date(year, month + 1, 0);
    // console.log(ddd);
    // console.log(ddd.getDate());
    if (date[0] > 0 & date[0] <= ddd.getDate() & date[1] > 0 & date[1] <= 12 & date[2] <= ddd.getFullYear() + 543) {
        if (date[0].length === 2 & date[1].length === 2) {
            // console.log("sss1");
        } else {
            var date1 = ""
            var date2 = ""
            if (date[0].length === 1) {
                date1 = "0"
            }
            if (date[1].length === 1) {
                date2 = "0"
            }
            data = date1 + date[0] + "/" + date2 + date[1] + "/" + date[2]
        }
        if (date[2].length !== 4) {
            data = ""
        }
    } else {
        data = ""
    }
    return data
}